import { ReactElement } from "react";
import { Box, Button, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { BasicPageLayout } from "../../../components/templates/BasicPageLayout";
import { useLocation } from "react-router-dom";
import { isValidAnalysisErrorReason } from "../../../types";
import { useModifiedTranslation } from "../../../hooks/useModifiedTranslation";
import { useDefaultPath } from "../../../hooks/useDefaultPath";

export function AnalysisError(): ReactElement {
  const defaultPath = useDefaultPath();
  const t = useModifiedTranslation();
  const { state } = useLocation();
  const isReason = isValidAnalysisErrorReason(state);
  const errorResponseCode = isReason ? state.code : "Unknown";
  const errorResponseMessage = isReason ? state.message : "Unknown";

  return (
    <BasicPageLayout title={t("AnalysisError.HeadingTitle")}>
      <VStack spacing={10} align="center">
        <Box>code : {errorResponseCode}</Box>
        <Box>message : {errorResponseMessage}</Box>
        <Button
          as={Link}
          to={defaultPath}
          variant="btn_primary"
          px={8}
          leftIcon={<IoHome />}
        >
          {t("AnalysisError.Back_to_Home")}
        </Button>
      </VStack>
    </BasicPageLayout>
  );
}
